import { StyleSheet, Font } from "@react-pdf/renderer";

Font.register({
  family: "Inter",
  fonts: [
    {
      src: "/fonts/Inter-VariableFont_opsz,wght.ttf",
      // @ts-expect-error - react-pdf types do not include format TODO verify if this is needed or not
      format: "truetype",
    },
  ],
});

export const styles = StyleSheet.create({
  page: {
    padding: 27,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: "#ddd",
    paddingBottom: 9,
  },
  section: {
    marginBottom: 11,
    padding: 9,
  },
  logo: {
    width: 63,
    height: 63,
  },
  text: {
    fontFamily: "Inter",
    fontSize: 10.5,
    marginBottom: 3.5,
  },
  question: {
    fontFamily: "Inter",
    fontSize: 12.5,
    fontWeight: "bold",
    marginBottom: 4.5,
  },
  answer: {
    fontFamily: "Inter",
    fontSize: 10.5,
    marginLeft: 9,
    marginBottom: 3.5,
  },
  relevantYear: {
    fontSize: 10.5,
    marginLeft: 9,
    color: "#555",
    marginBottom: 3.5,
  },
  comment: {
    fontSize: 10.5,
    marginLeft: 9,
    fontStyle: "italic",
    color: "#777",
    marginTop: 3.5,
  },
});
